import { render } from "./RssNews.vue?vue&type=template&id=382485ab&scoped=true"
import script from "./RssNews.vue?vue&type=script&lang=js"
export * from "./RssNews.vue?vue&type=script&lang=js"

import "./RssNews.vue?vue&type=style&index=0&id=382485ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382485ab"]])

export default __exports__